import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOpera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#opera_svg__a)' rx={9.5} />
    <defs>
      <pattern id='opera_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#opera_svg__b' transform='scale(.00195)' />
      </pattern>
      <image
        xlinkHref='/images/icons/opera-1ea36c3f.webp'
        id='opera_svg__b'
        width={512}
        height={512}
      />
    </defs>
  </svg>
);
export default SvgOpera;
